import React from "react";
import { Table } from "antd";
import "./style.css";

const GenericTable = ({ title, dataSource, columns }) => {
  return (
    <div className="table-generic">
      <div className="title">
        <span>{title}</span>
      </div>

      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey={(record, index) => record.key || index}
        pagination={true}
        bordered
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default GenericTable;
